import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row mb-5"
}
const _hoisted_2 = { key: 1 }

import BoxCardComponent from "@/views/dashboard/componets/BoxCardComponent.vue";
import {defineComponent, computed, onMounted, ref, watch} from 'vue'
import {useStore} from 'vuex'
import {useRoute} from 'vue-router'
import LoadingComponent from "@/components/LoadingComponent.vue";
import {triggerErrorNotification} from "@/utils/helper";
import {getPosReport} from "@/services/CashierService";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryReportComponent',
  setup(__props) {

defineComponent({
  name: 'SummaryReportComponent'
})

const isLoading = ref(true)

const store = useStore()
const route = useRoute()
const date: any = ref({})
const totalSales = computed(() => store.getters['restoReport/totalSales'])
const totalUnpaidSales = computed(() => store.getters['restoReport/totalUnpaidSales'])
const totalPaidSales = computed(() => store.getters['restoReport/totalPaidSales'])
const totalOrder = computed(() => store.getters['restoReport/totalOrder'])

watch(() => route.query, (val) => {
  date.value = Object.assign({
    startDate: route.query.startDate,
    endDate: route.query.endDate
  })
})

watch(date, () => {
  if(date.value.startDate) getReport()
})

const getReport = async () => {
  isLoading.value = true
  try {
    const parameter = {
      startDate: date.value.startDate,
      endDate: date.value.endDate
    }
    const response = await getPosReport(parameter)
    store.commit('restoReport/setData', response.data.data)
  } catch (e) {
    triggerErrorNotification(e)
  }

  isLoading.value = false
}

onMounted(() => {
  date.value = Object.assign({
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD')
  })
  if (route.query.startDate) {
    date.value = Object.assign({
      startDate: route.query.startDate,
      endDate: route.query.endDate
    })
  }
})


return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BoxCardComponent, {
          "card-class": `bg-primary`,
          content: _unref(totalSales),
          title: `Total Sales`
        }, null, 8, ["content"]),
        _createVNode(BoxCardComponent, {
          "card-class": `bg-info`,
          content: _unref(totalPaidSales),
          title: `Paid Order Amount`
        }, null, 8, ["content"]),
        _createVNode(BoxCardComponent, {
          "card-class": `bg-danger`,
          content: _unref(totalUnpaidSales),
          title: `Unpaid Order Amount`
        }, null, 8, ["content"]),
        _createVNode(BoxCardComponent, {
          "card-class": `bg-secondary`,
          content: _unref(totalOrder),
          title: `Total Order`
        }, null, 8, ["content"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(LoadingComponent)
      ]))
}
}

})